/**
 * i18n bootstrap — runs once at import time before any component renders.
 *
 * Strategy:
 * - English (en) is the source-of-truth language; Hindi (hi) is the second
 *   shipping locale. Both bundled inline (small) — no async chunk fetching
 *   so the first paint never blocks on translations.
 * - LanguageDetector picks from: ?lng=, localStorage, navigator, fallback.
 * - Keys follow a flat dotted convention: `section.element.modifier`
 *   e.g. `nav.login`, `home.hero.cta_primary`, `auth.login.email_label`.
 *
 * Adding strings:
 *   1. Add the English key to `en.common`.
 *   2. Add the Hindi translation to `hi.common`.
 *   3. In any component: `const { t } = useTranslation(); t('your.key')`.
 *
 * Phase 54 ships nav + footer + home hero + auth forms. Remaining pages
 * will be migrated incrementally — until a component uses `t()`, English
 * strings continue to render unchanged.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import hi from './locales/hi.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      hi: { common: hi },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi'],
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'ibclub_lng',
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  });

export default i18n;
